import { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import TabKanbanModulos from "./TabKanbanModulos";
import TabKanbanTarefas from "./TabKanbanTarefas";

export default function TabKanban() {
    const [subTab, setSubTab] = useState(0);

    return (
        <Box>
            <Tabs
                value={subTab}
                onChange={(_, v) => setSubTab(v)}
                sx={{ borderBottom: '1px solid', borderColor: 'divider', mb: 2 }}
                variant="standard"
            >
                <Tab label="Módulos" sx={{ textTransform: 'none' }} />
                <Tab label="Tarefas" sx={{ textTransform: 'none' }} />
            </Tabs>

            {subTab === 0 ? <TabKanbanModulos /> : <></>}
            {subTab === 1 ? <TabKanbanTarefas /> : <></>}
        </Box>
    );
}
